import PraisoServices from "./PraisoServices";

export const ResetPasswordAPI = async (params) => {
  const ApiUrl = `auth/reset-password`;
  let header = {};
  if (params.token) {
    header[`Authorization`] = `Bearer ${params.token}`;
  }
  let payload:any = {};
  if (params) {
    if (params.email) {
      payload.email = params.email;
    }
    if (params.token) {
      payload.sessionKey = params.token;
    }
    if (params.password) {
      payload.password = params.password;
    }
    if (params.confirmPassword) {
      payload.confirmPassword = params.confirmPassword;
    }
    if (params.isTokenStatusCheck) {
      payload.isTokenStatusCheck = params.isTokenStatusCheck;
    }
  }

  try {
    const response = await PraisoServices(
      ApiUrl,
      "post",
      {
        ...payload,
      },
      {},
      { ...header }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const ValidateResetPasswordLinkAPI = async (params) => {
  const ApiUrl = `auth/reset-password`;
  try {
    const response = await PraisoServices(
      ApiUrl,
      "get",
      {
        // ...payload
      },
      { ...params },
      {
        // ...header
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const getResetPassword = async (
  email,
  token,
  password,
  confirmPassword
) => {
  const data = await ResetPasswordAPI({
    email,
    token,
    password,
    confirmPassword,
  });
  if (
    data.status.code !== 0 &&
    data.status.code !== 200 &&
    data.status.code !== 201
  ) {
    const _message =
      data.status && data.status.message && data.status.message.length > 0
        ? data.status.message
        : "An error occured.";
    const _status = { code: data.status.code, message: _message };
    const _data = { ...data, status: _status };
    return { ..._data };
  } else {
    return {
      ...data,
    };
  }
};

export const doValidateResetPasswordLink = async (params) => {
  const data = await ValidateResetPasswordLinkAPI(params);
  return data;
};
